import {
  parseFamilyDashboardResponse,
  parseFamilyOccurrenceAbsenceDetail,
  parseFamilyScheduleResponse,
  parseFamilyStudentDetail,
  parseFamilyStudentsResponse
} from "@madamuh/domain";
import type {
  FamilyDashboardResponseDto,
  FamilyOccurrenceAbsenceDetailDto,
  FamilyScheduleResponseDto,
  FamilyStudentDetailDto,
  FamilyStudentsResponseDto,
  ReportStudentAbsenceRequestDto,
  CancelStudentAbsenceRequestDto
} from "@madamuh/domain";
import { apiGet, apiPost } from "./client";

export async function fetchFamilyDashboard(tenantSlug: string): Promise<FamilyDashboardResponseDto> {
  const response = await apiGet<unknown>(`/api/v1/app/tenants/${tenantSlug}/dashboard`);
  return parseFamilyDashboardResponse(response);
}

export async function fetchFamilyStudents(tenantSlug: string): Promise<FamilyStudentsResponseDto> {
  const response = await apiGet<unknown>(`/api/v1/app/tenants/${tenantSlug}/students`);
  return parseFamilyStudentsResponse(response);
}

export async function fetchFamilyStudentDetail(
  tenantSlug: string,
  studentId: string
): Promise<FamilyStudentDetailDto> {
  const response = await apiGet<unknown>(`/api/v1/app/tenants/${tenantSlug}/students/${studentId}`);
  return parseFamilyStudentDetail(response);
}

export async function fetchFamilySchedule(tenantSlug: string): Promise<FamilyScheduleResponseDto> {
  const response = await apiGet<unknown>(`/api/v1/app/tenants/${tenantSlug}/schedule`);
  return parseFamilyScheduleResponse(response);
}

export async function fetchFamilyOccurrenceAbsence(
  tenantSlug: string,
  occurrenceId: string
): Promise<FamilyOccurrenceAbsenceDetailDto> {
  const response = await apiGet<unknown>(`/api/v1/app/tenants/${tenantSlug}/occurrences/${occurrenceId}/absence`);
  return parseFamilyOccurrenceAbsenceDetail(response);
}

export async function reportFamilyOccurrenceAbsence(
  tenantSlug: string,
  occurrenceId: string,
  request: ReportStudentAbsenceRequestDto
): Promise<FamilyOccurrenceAbsenceDetailDto> {
  const response = await apiPost<ReportStudentAbsenceRequestDto, unknown>(
    `/api/v1/app/tenants/${tenantSlug}/occurrences/${occurrenceId}/absence`,
    request
  );
  return parseFamilyOccurrenceAbsenceDetail(response);
}

export async function cancelFamilyOccurrenceAbsence(
  tenantSlug: string,
  occurrenceId: string,
  request: CancelStudentAbsenceRequestDto
): Promise<FamilyOccurrenceAbsenceDetailDto> {
  const response = await apiPost<CancelStudentAbsenceRequestDto, unknown>(
    `/api/v1/app/tenants/${tenantSlug}/occurrences/${occurrenceId}/absence/cancel`,
    request
  );
  return parseFamilyOccurrenceAbsenceDetail(response);
}
